import React, { FC, memo, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import TabsPanelV2 from 'components/Common/TabsPanelV2'
import ToolGetHelp from 'components/Owner/Tools/ToolFlyout/ToolGetHelp'
import ToolGetPlays from 'components/Owner/Tools/ToolFlyout/ToolGetPlays'
import ToolLearnMore from 'components/Owner/Tools/ToolFlyout/ToolLearnMore'
import ToolBreadCrumb from 'components/Owner/Tools/ToolFlyout/ToolBreadCrumb'
import ToolDiagnostics from 'components/Owner/Tools/ToolFlyout/ToolDiagnostics'
import ToolFlyoutMenuHeader from 'components/Owner/Tools/ToolFlyout/ToolFlyoutMenuHeader'
import { getCurrentRoute, getReturnToPath, scrollToTop } from 'utils/helper'
import history from 'utils/history'
import { ExtendedTools } from 'types'
import { ampli } from 'ampli'
import { TOOL_FLYOUT_OPTIONS, toolsTabs } from 'config'
import GradientCircleNotchIcon from 'components/Common/SvgIcons/GradientCircleNotchIcon'

export interface IToolFlyoutMenuProps {
  toolDetail: ExtendedTools
  myTools: ExtendedTools[]
  allTools: ExtendedTools[]
  getMyToolsAction: () => void
  getAllToolsAction: (payload?: { tenantId: string }) => void
}
const ToolFlyoutMenu: FC<IToolFlyoutMenuProps> = ({
  toolDetail,
  myTools,
  allTools,
  getMyToolsAction,
  getAllToolsAction,
}) => {
  const { toolFlyTab } = useParams<TOOL_FLYOUT_OPTIONS>()
  const [activeTabName, setActiveTabName] = useState<TOOL_FLYOUT_OPTIONS>(toolFlyTab)

  let path = getCurrentRoute()
  const toolsPath = path.slice(0, path.lastIndexOf('/'))

  const onChange = (flyOutTab) => {
    let queryParam = getReturnToPath()
    setActiveTabName(flyOutTab.name)
    history.push(`${toolsPath}/${flyOutTab.name}?toolId=${queryParam.toolId}`)
  }

  useEffect(() => {
    const isMyToolsTab = getCurrentRoute().includes(toolsTabs[0].link) ? true : false
    const tools = getCurrentRoute().includes(toolsTabs[0].link) ? myTools : allTools

    if (tools.length === 0 && isMyToolsTab) {
      getMyToolsAction()
    } else if (tools.length === 0 && !isMyToolsTab) {
      getAllToolsAction()
    }
    scrollToTop()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    ampli.toolFlyoutTabAccessed({ tabName: toolFlyTab, toolName: toolDetail?.toolName! })
    // eslint-disable-next-line
  }, [path])

  let ToolFlyOutMenuComponent = {
    [TOOL_FLYOUT_OPTIONS.LEARN_MORE]: ToolLearnMore,
    [TOOL_FLYOUT_OPTIONS.PLAYS]: ToolGetPlays,
    [TOOL_FLYOUT_OPTIONS.DIAGNOSTICS]: ToolDiagnostics,
    [TOOL_FLYOUT_OPTIONS.HELP]: ToolGetHelp,
  }

  let ToolFlyOutMenuProps = {
    [TOOL_FLYOUT_OPTIONS.LEARN_MORE]: {
      longDescription: toolDetail.longDescription || '',
    },
    [TOOL_FLYOUT_OPTIONS.PLAYS]: {},
    [TOOL_FLYOUT_OPTIONS.DIAGNOSTICS]: {},
    [TOOL_FLYOUT_OPTIONS.HELP]: {
      toolHelpText: toolDetail.toolHelpText || '',
    },
  }

  return !toolDetail.toolFlyoutOptions ? (
    <div className="h-full flex flex-col items-center p-10">
      <GradientCircleNotchIcon width="100" height="100" />
    </div>
  ) : (
    <div className="w-full sm:px-10">
      <ToolBreadCrumb title={toolDetail.toolDisplayName || ''} />
      <ToolFlyoutMenuHeader toolDetail={toolDetail} />

      <TabsPanelV2
        activeTabName={activeTabName}
        tabs={toolDetail.toolFlyoutOptions!}
        onChange={onChange}
      />
      {toolDetail.toolFlyoutOptions!.map((option) => {
        if (option.name === activeTabName) {
          const Component = ToolFlyOutMenuComponent[option.name]
          return (
            <div className="mt-16 pt-2">
              <Component {...ToolFlyOutMenuProps[option.name]} />
            </div>
          )
        }
        return null
      })}
    </div>
  )
}

export default memo(ToolFlyoutMenu)
